import React from 'react'

import Trator from 'entity/Trator'
import SeletorCliente from 'entity/Cliente/components/SeletorCliente'

import DefaultEntityCrud from 'components/form/DefaultEntityCrud'
import FormContent from 'components/form/FormContent'
import TextInput from 'components/form/input/TextInput'
import SelectInput from 'components/form/input/SelectInput'
import FormRow from 'components/form/FormRow'


function TratorFormInter(props) {
    return (
        <FormContent sx={{ p: 2 }}>
            <FormRow>
                <TextInput
                    sx={{ flex: 0.5 }}
                    name="sequencialIndex"
                    label="Código"
                    InputLabelProps={{
                        shrink: true,
                    }}
                    type="number"
                    disabled
                />
                <SelectInput
                    sx={{ flex: 0.5 }}
                    name="status"
                    label="Status"
                    options={["ATIVO", "INATIVO"]}
                    required
                />
                <SeletorCliente
                    sx={{ flex: 2 }}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    required
                />
            </FormRow>

            <FormRow>
                <TextInput
                    sx={{ flex: 0.25 }}
                    name="numeroFrotaTrator"
                    label="nº Frota"
                    InputLabelProps={{
                        shrink: true,
                    }}
                    required
                />
                <TextInput
                    sx={{ flex: 0.5 }}
                    name="marcaTrator"
                    label="Marca"
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
                <TextInput
                    sx={{ flex: 0.5 }}
                    name="modeloTrator"
                    label="Modelo"
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
                <TextInput
                    sx={{ flex: 0.5 }}
                    name="nomeOperador"
                    label="Operador"
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
            </FormRow>
        </FormContent>
    )
}

export default function TratorForm() {
    return (
        <DefaultEntityCrud
            title={"Cadastro de Trator"}
            EntityClass={Trator}
            routeForm={"_trator"}
            backRoute="consulta-trator"

            formActions={{ novoForm: false, salvarForm: true, sairForm: true }}
        >
            {(props) => <TratorFormInter {...props} />}
        </DefaultEntityCrud>
    )
}
